import React from 'react';
import user5 from './assets/images/user-5.png';
import user4 from './assets/images/user-4.png';
import user3 from './assets/images/user-3.png';
import feedbackBg from './assets/images/feedback-bg.png';

const Testimonial = () => {
    return (
        // <!-- Testimonial -->
        <section id="testimonial" className="testimonial section">
            <div
                className="bg__holder"
                style={{ background: `url(${feedbackBg})`, backgroundSize: 'cover' }}
            ></div>
            {/* <!--// bg__holder  --> */}
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <p className="section__para one" data-aos="fade-up">#TESTIMONIAL</p>
                        <h2 className="heading__1" data-aos="fade-up">Feedbacks</h2>
                        <p className="section__para two" data-aos="fade-up">
                            Streamers & Influencers
                        </p>
                    </div>
                </div>
                <section className='grid lg:grid-cols-3 gap-8'
                data-aos="fade-up">
                    <div className="card w-90 text-white bg-black shadow-xl">
                        <div className='flex m-1 p-1'>
                            <div className="avatar">
                                <div className="w-20 rounded-full ">
                                    <img src={user4} />
                                </div>
                            </div>
                            <div className="card-box">

                                <div className="card-box__content ml-3">
                                    <h5 className="card-box__title">Kimberly</h5>
                                    <p className="designation">Gamer/Creator</p>
                                </div>
                            </div>
                        </div>
                        <div className="rating ml-4">
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" checked />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                        </div>
                        <p className="card-box__text m-2">
                            “Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. ”
                        </p>

                    </div>
                    <div className="card w-90 text-white bg-black shadow-xl">
                        <div className='flex m-1 p-1'>
                            <div className="avatar">
                                <div className="w-20 rounded-full ">
                                    <img src={user3} />
                                </div>
                            </div>
                            <div className="card-box">

                                <div className="card-box__content ml-3">
                                    <h5 className="card-box__title">Dr. Crypto Vendor</h5>
                                    <p className="designation">Content Creator</p>
                                </div>
                            </div>
                        </div>
                        <div className="rating ml-4">
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" checked />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                        </div>
                        <p className="card-box__text m-2">
                            “Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. ”
                        </p>

                    </div>
                    <div className="card w-90 text-white bg-black shadow-xl">
                        <div className='flex m-1 p-1'>
                            <div className="avatar">
                                <div className="w-20 rounded-full ">
                                    <img src={user5} />
                                </div>
                            </div>
                            <div className="card-box">

                                <div className="card-box__content ml-3">
                                    <h5 className="card-box__title">Lily</h5>
                                    <p className="designation">Gamer/Creator</p>
                                </div>
                            </div>
                        </div>
                        <div className="rating ml-4">
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" checked />
                            <input type="radio" name="rating-2" className="mask mask-star-2 bg-orange-400" />
                        </div>
                        <p className="card-box__text m-2">
                            “Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. ”
                        </p>

                    </div>
                    



                </section>




                {/* <section
             
            >
              <div className="splide__track">
                <ul className="splide__list">
                  <li className="splide__slide">
                    <div className="card-box">
                      <div className="user">
                        <div className="user__img">
                          <img
                            src={user4}
                            alt="Client"
                            width="116"
                            height="146"
                            className="img-fluid"
                          />
                        </div>
                        <div className="card-box__content">
                          <h5 className="card-box__title">Kimberly</h5>
                          <p className="designation">Gamer/Creator</p>
                        </div>
                      </div>
                      <div className="stars">
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                      </div>
                      <p className="card-box__text">
                        “Lorem ipsum dolor sit amet, consectetur adipiscing
                        elit, sed do eiusmod tempor incididunt ut labore et
                        dolore magna aliqua. ”
                      </p>
                    </div>
                  </li>
                  <li className="splide__slide">
                    <div className="card-box">
                      <div className="user">
                        <div className="user__img">
                          <img
                            src={user3}
                            alt="Client"
                            width="116"
                            height="146"
                            className="img-fluid"
                          />
                        </div>
                        <div className="card-box__content">
                          <h5 className="card-box__title">Dr. Crypto Vendor</h5>
                          <p className="designation">Content Creator</p>
                        </div>
                      </div>
                      <div className="stars">
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                      </div>
                      <p className="card-box__text">
                        “Lorem ipsum dolor sit amet, consectetur adipiscing
                        elit, sed do eiusmod tempor incididunt ut labore et
                        dolore magna aliqua. ”
                      </p>
                    </div>
                  </li>
                  <li className="splide__slide">
                    <div className="card-box">
                      <div className="user">
                        <div className="user__img">
                          <img
                            src={user5}
                            alt="Client"
                            width="116"
                            height="146"
                            className="img-fluid"
                          />
                        </div>
                        <div className="card-box__content">
                          <h5 className="card-box__title">Lily</h5>
                          <p className="designation">Content Creator</p>
                        </div>
                      </div>
                      <div className="stars">
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                      </div>
                      <p className="card-box__text">
                        “Lorem ipsum dolor sit amet, consectetur adipiscing
                        elit, sed do eiusmod tempor incididunt ut labore et
                        dolore magna aliqua. ”
                      </p>
                    </div>
                  </li>
                  <li className="splide__slide">
                    <div className="card-box">
                      <div className="user">
                        <div className="user__img">
                          <img
                            src={user4}
                            alt="Client"
                            width="116"
                            height="146"
                            className="img-fluid"
                          />
                        </div>
                        <div className="card-box__content">
                          <h5 className="card-box__title">Kimberly</h5>
                          <p className="designation">Gamer/Creator</p>
                        </div>
                      </div>
                      <div className="stars">
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                        <span className="star">
                          <svg
                            version="1.2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="18"
                          >
                            <path
                              d="m10.1.1 3.1 5.6 6.2 1.2-4.3 4.6.7 6.4-5.7-2.7-5.8 2.7.8-6.4L.8 6.9 7 5.7 10.1.1"
                              style="fill: #feb600"
                            />
                          </svg>
                        </span>
                      </div>
                      <p className="card-box__text">
                        “Lorem ipsum dolor sit amet, consectetur adipiscing
                        elit, sed do eiusmod tempor incididunt ut labore et
                        dolore magna aliqua. ”
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </section> */}
            </div>
        </section>
        // <!-- Testimonial -->
    );
};

export default Testimonial;